(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["form-trap"] && !Shopify.designMode) return;
  try {
    (() => {
    // People take longer than this to fill in a contact form
    const MIN_TIME = 2500;

    document.addEventListener('submit', (event) => {
      const trap = event.target.querySelector?.('[data-form-trap]');
      if (!trap) return;
      if (trap.value !== '' || performance.now() < MIN_TIME) event.preventDefault();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hero-rail"] && !Shopify.designMode) return;
  try {
    (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.addEventListener('click', (event) => {
      const scroll = event.target.closest('[data-hero-scroll]');
      if (!scroll) return;

      const section = scroll.closest('.shopify-section');
      const next = section?.nextElementSibling;
      const behavior = reduceMotion.matches ? 'auto' : 'smooth';
      if (next) {
        next.scrollIntoView({ behavior, block: 'start' });
      } else if (section) {
        window.scrollTo({ top: section.getBoundingClientRect().bottom + window.scrollY, behavior });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    // data-scrolled once the page leaves the top: the badge stays turned while the
    // visitor reads on.
    let scrolled = null;

    const update = () => {
      const now = window.scrollY > 0;
      if (now === scrolled) return;
      scrolled = now;
      document.querySelectorAll('.scroll-badge').forEach((badge) => badge.toggleAttribute('data-scrolled', now));
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('shopify:section:load', () => {
      scrolled = null;
      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["select"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('custom-select')) return;

    class CustomSelect extends HTMLElement {
      connectedCallback() {
        if (this.combobox) return;

        this.native = this.querySelector('select');
        if (!this.native || !this.native.id) return;

        const id = this.native.id;
        const label = document.querySelector(`label[for="${CSS.escape(id)}"]`);
        if (label && !label.id) label.id = `${id}-label`;

        this.items = [];
        this.activeIndex = -1;
        this.search = '';
        this.searchTimer = null;
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.combobox = document.createElement('div');
        this.combobox.className = 'field__input select__combobox';
        this.combobox.id = `${id}-combobox`;
        this.combobox.tabIndex = 0;
        this.combobox.setAttribute('role', 'combobox');
        this.combobox.setAttribute('aria-haspopup', 'listbox');
        this.combobox.setAttribute('aria-expanded', 'false');
        this.combobox.setAttribute('aria-controls', `${id}-listbox`);
        if (label) this.combobox.setAttribute('aria-labelledby', label.id);
        if (this.native.required) this.combobox.setAttribute('aria-required', 'true');

        this.valueText = document.createElement('span');
        this.valueText.className = 'select__combobox-text';
        this.combobox.append(this.valueText);

        this.listbox = document.createElement('ul');
        this.listbox.className = 'select__listbox';
        this.listbox.id = `${id}-listbox`;
        this.listbox.tabIndex = -1;
        this.listbox.hidden = true;
        this.listbox.setAttribute('role', 'listbox');
        if (label) this.listbox.setAttribute('aria-labelledby', label.id);

        for (const option of this.native.options) {
          if (option.disabled && option.value === '') {
            this.placeholder = option.textContent.trim();
            continue;
          }
          const item = document.createElement('li');
          item.className = 'select__option';
          item.id = `${id}-option-${this.items.length}`;
          item.textContent = option.textContent.trim();
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', 'false');
          this.items.push({ value: option.value, label: item.textContent, element: item });
          this.listbox.append(item);
        }

        this.native.tabIndex = -1;
        this.native.setAttribute('aria-hidden', 'true');
        this.native.after(this.combobox, this.listbox);
        this.dataset.enhanced = '';
        this.sync();

        this.combobox.addEventListener('click', () => (this.isOpen ? this.close() : this.open()), { signal });
        this.combobox.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.listbox.addEventListener('mousedown', (event) => event.preventDefault(), { signal });
        this.listbox.addEventListener('click', (event) => this.onOptionClick(event), { signal });
        this.listbox.addEventListener('mousemove', (event) => this.onOptionHover(event), { signal });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        }, { signal });
        this.native.addEventListener('focus', () => this.combobox.focus(), { signal });
        this.native.addEventListener('change', () => this.sync(), { signal });
        this.native.addEventListener('invalid', () => this.combobox.setAttribute('aria-invalid', 'true'), { signal });
        this.native.form?.addEventListener('reset', () => requestAnimationFrame(() => this.sync()), { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.searchTimer);
      }

      get isOpen() {
        return !this.listbox.hidden;
      }

      get selectedIndex() {
        return this.items.findIndex((item) => item.value === this.native.value);
      }

      sync() {
        const index = this.selectedIndex;
        this.items.forEach((item, i) => item.element.setAttribute('aria-selected', String(i === index)));
        if (index > -1) {
          this.valueText.textContent = this.items[index].label;
          delete this.combobox.dataset.placeholder;
        } else {
          this.valueText.textContent = this.placeholder || '';
          this.combobox.dataset.placeholder = '';
        }
        if (this.native.checkValidity()) this.combobox.removeAttribute('aria-invalid');
      }

      open(index = this.selectedIndex) {
        if (this.isOpen || !this.items.length) return;
        this.listbox.hidden = false;
        this.dataset.open = '';
        this.combobox.setAttribute('aria-expanded', 'true');
        this.setActive(index > -1 ? index : 0);
      }

      close() {
        if (!this.isOpen) return;
        this.listbox.hidden = true;
        delete this.dataset.open;
        this.combobox.setAttribute('aria-expanded', 'false');
        this.combobox.removeAttribute('aria-activedescendant');
        this.setActive(-1);
      }

      setActive(index) {
        this.items[this.activeIndex]?.element.removeAttribute('data-active');
        this.activeIndex = index;
        const item = this.items[index];
        if (!item) return;
        item.element.dataset.active = '';
        this.combobox.setAttribute('aria-activedescendant', item.element.id);
        item.element.scrollIntoView({ block: 'nearest' });
      }

      choose(index) {
        const item = this.items[index];
        if (!item) return;
        if (this.native.value !== item.value) {
          this.native.value = item.value;
          this.native.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.sync();
      }

      onOptionClick(event) {
        const element = event.target.closest('[role="option"]');
        if (!element) return;
        this.choose(this.items.findIndex((item) => item.element === element));
        this.close();
        this.combobox.focus();
      }

      onOptionHover(event) {
        const element = event.target.closest('[role="option"]');
        if (!element) return;
        const index = this.items.findIndex((item) => item.element === element);
        if (index !== this.activeIndex) this.setActive(index);
      }

      typeahead(character) {
        clearTimeout(this.searchTimer);
        this.search += character.toLowerCase();
        this.searchTimer = setTimeout(() => (this.search = ''), 500);

        const start = this.isOpen ? this.activeIndex : this.selectedIndex;
        const ordered = [...this.items.slice(start + 1), ...this.items.slice(0, start + 1)];
        const match = ordered.find((item) => item.label.toLowerCase().startsWith(this.search));
        if (!match) return;

        const index = this.items.indexOf(match);
        if (this.isOpen) {
          this.setActive(index);
        } else {
          this.open(index);
        }
      }

      onKeydown(event) {
        const { key, altKey, ctrlKey, metaKey } = event;
        const last = this.items.length - 1;

        if (!this.isOpen) {
          if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(key)) {
            event.preventDefault();
            this.open();
          } else if (key === 'Home') {
            event.preventDefault();
            this.open(0);
          } else if (key === 'End') {
            event.preventDefault();
            this.open(last);
          } else if (key.length === 1 && !ctrlKey && !metaKey && !altKey) {
            this.typeahead(key);
          }
          return;
        }

        switch (key) {
          case 'ArrowDown':
            event.preventDefault();
            if (altKey) break;
            this.setActive(Math.min(this.activeIndex + 1, last));
            break;
          case 'ArrowUp':
            event.preventDefault();
            if (altKey) {
              this.choose(this.activeIndex);
              this.close();
            } else {
              this.setActive(Math.max(this.activeIndex - 1, 0));
            }
            break;
          case 'Home':
            event.preventDefault();
            this.setActive(0);
            break;
          case 'End':
            event.preventDefault();
            this.setActive(last);
            break;
          case 'PageDown':
            event.preventDefault();
            this.setActive(Math.min(this.activeIndex + 5, last));
            break;
          case 'PageUp':
            event.preventDefault();
            this.setActive(Math.max(this.activeIndex - 5, 0));
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            this.choose(this.activeIndex);
            this.close();
            break;
          case 'Escape':
            event.preventDefault();
            this.close();
            break;
          case 'Tab':
            this.choose(this.activeIndex);
            this.close();
            break;
          default:
            if (key.length === 1 && !ctrlKey && !metaKey && !altKey) {
              event.preventDefault();
              this.typeahead(key);
            }
        }
      }
    }

    customElements.define('custom-select', CustomSelect);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["service-icon"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('service-icon')) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 1023px), (orientation: portrait) and (max-width: 1366px)');
    let observer;

    class ServiceIcon extends HTMLElement {
      connectedCallback() {
        if (this.controller || reducedMotion.matches) return;

        this.controller = new AbortController();
        const { signal } = this.controller;

        // Entry animation is for mobile only (no hover there); on desktop the
        // icon stays observed, so it still plays if the device turns to mobile.
        observer ??= new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting && mobile.matches) entry.target.play(1);
            }
          },
          { threshold: 0.6 }
        );
        observer.observe(this);

        const trigger = this.closest('[data-icon-trigger]') ?? this;
        trigger.addEventListener(
          'pointerenter',
          (event) => {
            if (event.pointerType === 'mouse') this.play(Infinity);
          },
          { signal }
        );
        trigger.addEventListener(
          'pointerleave',
          (event) => {
            if (event.pointerType === 'mouse') this.finishCycle();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        observer?.unobserve(this);
        delete this.dataset.state;
      }

      get animations() {
        return this.getAnimations({ subtree: true });
      }

      play(loops) {
        observer.unobserve(this);

        const animations = this.animations;
        const running = animations.filter((animation) => animation.playState === 'running');

        // Already playing: keep the paths in step and just stop counting cycles.
        if (running.length) {
          if (loops !== Infinity) return;
          const elapsed = Math.max(...running.map((animation) => animation.currentTime));
          for (const animation of animations) {
            animation.effect.updateTiming({ iterations: Infinity });
            animation.currentTime = elapsed;
            animation.play();
          }
          return;
        }

        // Restart: drop the animations, force a style flush, apply them again.
        delete this.dataset.state;
        void this.offsetWidth;
        this.style.setProperty('--loops', loops === Infinity ? 'infinite' : String(loops));
        this.dataset.state = 'playing';
      }

      finishCycle() {
        for (const animation of this.animations) {
          const { currentIteration } = animation.effect.getComputedTiming();
          if (currentIteration !== null) animation.effect.updateTiming({ iterations: currentIteration + 1 });
        }
      }
    }

    customElements.define('service-icon', ServiceIcon);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-links"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', async (event) => {
      const share = event.target.closest('[data-social-share]');
      if (!share) return;

      const data = { title: document.title, url: window.location.href };
      if (navigator.share) {
        try {
          await navigator.share(data);
        } catch (error) {
          /* Share sheet dismissed */
        }
        return;
      }
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(data.url);
        const status = share.parentElement.querySelector('[data-social-share-status]');
        if (status) status.textContent = status.dataset.message;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
